/**
 * 容量有限的Map，当插入的元素数量大于最大值时，会移除老的元素
 */
export class SizeLimitedMap extends Map {
  /**
   * 最大长度，当小于等于0时，不限制
   */
  maxSize = 0;

  set(key: any, value: any) {
    if (this.maxSize > 0 && this.has(key)) {
      // 如果设置了最大长度，更新值时将元素移到最后
      this.delete(key);
    }
    super.set(key, value);
    const { size } = this;
    if (this.maxSize > 0 && size > this.maxSize) {
      const deleteLen = size - this.maxSize;
      const keys = this.keys();
      const deleteKeys = [];
      for (let i = 0; i < size; i++) {
        const item = keys.next().value;
        if (item !== key) {
          deleteKeys.push(item);
          if (deleteKeys.length >= deleteLen) {
            break;
          }
        }
      }
      deleteKeys.forEach((item) => {
        this.delete(item);
      });
    }
    return this;
  }

  toJSON() {
    return {
      dataType: "Map",
      value: Array.from(this.entries()),
    };
  }

  static jsonStringify(_key: any, value: any) {
    if (value instanceof Map) {
      return {
        dataType: "Map",
        value: Array.from(value.entries()),
      };
    }
    return value;
  }

  static jsonParse(_key: any, value: any) {
    if (typeof value === "object" && value !== null) {
      if (value.dataType === "Map") {
        return new Map(value.value);
      }
    }
    return value;
  }
}
